import cellSizeEditor from "../data/cellSizeEditor";
import widthBlockEditor from "../data/widthBlockEditor";

/**
 * The first (x,y) coordinates needs to be them of the block where the path is out and not enter
 * @param {*} x 
 * @param {*} y 
 * @param {*} _x 
 * @param {*} _y 
 * @param {*} height 
 * @param {*} _height 
 * @param {*} index 
 * @returns 
 */
function drawPath(x, y, _x =  null, _y = null , height = 3, _height = 3, index = 0) {

    const size = cellSizeEditor;
    const width = widthBlockEditor;
    // (x,y) couple and (_x,_y) couple : top left corner coordinates

    // If index != 0 means that the link if from a block child of a redirection block or statement block and we need to make a litte scale on the center of the block
    x = index == 0 ? x + ((width + 1) * size) - size : x + (width * size) - size / 2;

     // If index != 0 means that the link if from a block child of a redirection block or statement block and we to downside the coordinate
    y = index == 0 ? y + ((height + 0.5) * size) - (height / 2 * size) :  y + ((height - 1) * size) + ((index + 1) * size)
     // height == 2 meam's that we are dealing with a scenario block so we need to adjust the height a little bit
    y = y + (height == 2 ? 5 : 0);

    _x = _x;
    _y = _y + size / 2 + size * 0.5 * _height

    return drawPathFromCoord(x, y, _x, _y);
}

function drawPathFromCoord(x, y, _x, _y) {
    const stroke = x > _x ? "rgba(0, 0, 0, 0.1)" : "rgba(0, 0, 0, 0.25)";
    
    const offset = x > _x ? Math.min(x - _x + 85, 300) : 85; // With our coordinate we will draw a barrier curve, calculation of a barrier curve change for a certain angle who is represented by and abscisse

    return { data : `M${x} ${y} C ${x + offset} ${y}, ${_x - offset} ${_y},${_x} ${_y}` , stroke};
}

export default drawPath;
export { drawPathFromCoord, drawPath};
